import { Scoring } from "./Scoring";
import { Content } from "./Content";
import { EvaluationSettings } from "./EvaluationSettings";
import {
    GuxTabs,
    GuxTabList,
    GuxTabPanel,
    GuxTab,
    GuxIcon,
} from "genesys-spark-components-react";
import "./FormEditorSidePanel.less";
import strings from "./FormEditorSidePanel.strings";
import { useStrings } from "features/i18n/useStrings";
import { useAppSelector } from "app/hooks";
import { selectIsEvaluationSettingError } from "features/qualityForm/qualityFormSlice";
import {
    selectFormType,
    selectEvaluationFormType,
} from "features/qualityForm/qualityFormSlices/qualityFormCommons";
import FormType from "enums/FormType";
import { EvaluationFormEvaluationFormTypeEnum } from "@genesys/cloud-frontend/models/EvaluationForm";
import { useEffect, useState } from "react";
import { selectIsInCopyingViewMode } from "../copyFormSlice";

enum FormEditorSidePanelTabs {
    CONTENT = "content",
    SCORING = "scoring",
    SETTINGS = "settings",
}

export function FormEditorSidePanel() {
    const t = useStrings(strings);
    const formType = useAppSelector(selectFormType);
    const evaluationFormType = useAppSelector(selectEvaluationFormType);
    const defaultScoring = formType === FormType.ASSESSMENT;
    const [activeTab, setActiveTab] = useState<FormEditorSidePanelTabs>(
        defaultScoring
            ? FormEditorSidePanelTabs.SCORING
            : FormEditorSidePanelTabs.CONTENT
    );

    const isInCopyingViewMode = useAppSelector(selectIsInCopyingViewMode);

    const isEvaluationSettingsError = useAppSelector(
        selectIsEvaluationSettingError
    );

    useEffect(() => {
        if (isInCopyingViewMode) {
            setActiveTab(FormEditorSidePanelTabs.CONTENT);
        }
    }, [isInCopyingViewMode]);

    const showSettingsTab =
        evaluationFormType !== EvaluationFormEvaluationFormTypeEnum.Automated &&
        formType === FormType.EVALUATION;

    return (
        <div className="FormEditorSidePanel">
            <div className="tab-panel-options-list">
                <GuxTabs
                    active-tab={activeTab}
                    onGuxactivetabchange={(e) => {
                        setActiveTab(e.detail as FormEditorSidePanelTabs);
                    }}
                >
                    <GuxTabList slot="tab-list">
                        <GuxTab
                            tab-id={FormEditorSidePanelTabs.CONTENT}
                            onClick={() =>
                                setActiveTab(FormEditorSidePanelTabs.CONTENT)
                            }
                        >
                            <span>
                                <strong>{t.PanelOptions.Content}</strong>
                            </span>
                        </GuxTab>
                        <GuxTab
                            tab-id={FormEditorSidePanelTabs.SCORING}
                            onClick={() =>
                                setActiveTab(FormEditorSidePanelTabs.SCORING)
                            }
                        >
                            <span>
                                <strong>{t.PanelOptions.Scoring}</strong>
                            </span>
                        </GuxTab>
                        {showSettingsTab && (
                            <GuxTab
                                tab-id={FormEditorSidePanelTabs.SETTINGS}
                                onClick={() =>
                                    setActiveTab(
                                        FormEditorSidePanelTabs.SETTINGS
                                    )
                                }
                            >
                                <span className="settings-tab-header">
                                    <strong>{t.PanelOptions.Settings}</strong>
                                    {isEvaluationSettingsError && (
                                        <GuxIcon
                                            iconName="fa/hexagon-exclamation-solid"
                                            className="settings-alert-icon"
                                            screenreaderText={
                                                t.screenreader.settingsError
                                            }
                                        />
                                    )}
                                </span>
                            </GuxTab>
                        )}
                    </GuxTabList>
                    <GuxTabPanel tab-id={FormEditorSidePanelTabs.CONTENT}>
                        <Content />
                    </GuxTabPanel>
                    <GuxTabPanel tab-id={FormEditorSidePanelTabs.SCORING}>
                        <Scoring />
                    </GuxTabPanel>
                    {showSettingsTab && (
                        <GuxTabPanel tab-id={FormEditorSidePanelTabs.SETTINGS}>
                            <EvaluationSettings />
                        </GuxTabPanel>
                    )}
                </GuxTabs>
            </div>
        </div>
    );
}
